import cssVars from '@/css-vars.json';
import { Config } from '@/types/config';

export function setStyles (index: number, appConfig: Config) {
    const idAttr = 'data-odr-styles';

    let styleEl = document.querySelector(`style[${idAttr}="${index}"]`);
    if (!styleEl) {
        styleEl = document.createElement('style');
        styleEl.setAttribute(idAttr, String(index));
        document.head.appendChild(styleEl);
    }

    styleEl.innerHTML = `
        [data-odr-widget="${index}"], [data-odr-wrap="${index}"] {
            --odr-z-index: ${appConfig.zIndex} !important;
            ${Object.keys(cssVars).map(key => `${key}: ${cssVars[key]} !important;`).join('\n')}
            ${!appConfig.customizing ? '' : Object.keys(appConfig.customizing).map(key => `--odr-${key}: ${appConfig.customizing[key]} !important;`).join('\n')}
        }

        @media print {
            .odr-g-no-print {
                display: none !important;
            }
        }
    `;
}
